import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { format_date } from '../../../Utils/Dateutils';
import { deleteStitchReturn } from '../../../Store/PHPSlice/Stitching/StitchApi';

const TableBody = ({
    serialNumber,
    id,
    dt,
    stId,
    reMemo,
    stMemo,
    piMemo,
    empNm,
    itemNm,
    totQty,
    reQty,
    remainqty,
    mtqty,
    balmtqty,
    remtq,
    sts,
    pay_sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("you want to delete this Job Return?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteStitchReturn(stId))
                .then(() => {
                    // Reload the page to show updated results
                    // toast.success("Cloth Issue Deleted Sucessfully");
                    alert("Job Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }


    };

    const handleViewClick = () => {
        window.open(`/StitchReturnInfo/${stId}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };

    const handleFinalPrintClick = () => {
        window.open(`/stitch-final-return/${stId}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };

    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        // window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {format_date(dt)}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {piMemo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {stMemo}
                </TableCell>



                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {totQty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {reQty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {remainqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {mtqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {remtq}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {balmtqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '0.9rem' }} align='center'>
                    <h3 style={{ fontSize: '0.9rem', color: 'blue' }} className='cursor-pointer' onClick={handleFinalPrintClick}>Final Print</h3>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${pay_sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
